import ButtonSuccessIcon from './ButtonSuccessIcon';

export default ButtonSuccessIcon;
